import React from 'react';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import ProductDentalRow from '../ProductDentalRow';
import '../styles/product-selection.scss';

const planData = [
  {
    planId: 'dentalplan1',
    currentPlan: true,
    planTitle: 'PureLife Health Suvidha Guard',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$100.00',
    monthlyAmount: '',
    tierRating: '3.0',
    starRating: '3',
    copay: '$20.00',
    coinsurance: '$75.00',
    patientResponsibility: '$20.00',
    primaryCareProvider: 'Required',
    networks: [
      'Preferred Provider Organization (PPO)',
      'Health Maintenance Organization (HMO)',
      'Exclusive Provider Organization(EPO)',
      'Point of Service (POS)',
      'Indemnity Plan (Fee-for-Service)',
      'Dental Maintenance Organization (DMO)',
    ],
    genricDrugs: ['$70 (brand)', '$30 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
    ],
  },
  {
    planId: 'dentalplan2',
    currentPlan: false,
    planTitle: 'WellGuard Health Shield',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$156.00',
    monthlyAmount: '+$56.00',
    tierRating: '2.0',
    starRating: '4',
    copay: '$22.00',
    coinsurance: '$18.00',
    patientResponsibility: '$22.00',
    primaryCareProvider: 'Not Required',
    networks: [
      'Preferred Provider Organization (PPO)',
      'Indemnity Plan (Fee-for-Service)',
      'Dental Maintenance Organization (DMO)',
    ],
    genricDrugs: ['$120 (brand)', '$30 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
      'Mental Health Services',
      'Rehabilitation Services',
      'Preventive Services',
      'Chronic Disease Management',
      'Home Health Care',
      'Hospice Care',
    ],
  },
  {
    planId: 'dentalplan3',
    currentPlan: false,
    planTitle: 'WellGuard Health Shield',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$96.00',
    monthlyAmount: '-$4.00',
    tierRating: '1.0',
    starRating: '5',
    copay: '$0.00',
    coinsurance: '-',
    patientResponsibility: 'Not Applicable',
    primaryCareProvider: 'Required',
    networks: [
      'Preferred Provider Organization (PPO)',
      'Health Maintenance Organization (HMO)',
      'Exclusive Provider Organization(EPO)',
      'Point of Service (POS)',
      'Indemnity Plan (Fee-for-Service)',
      'Dental Maintenance Organization (DMO)',
      'Dual Network Plan',
    ],
    genricDrugs: ['$200 (brand)', '$80 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
      'Mental Health Services',
      'Rehabilitation Services',
      'Preventive Services',
      'Chronic Disease Management',
      'Home Health Care',
      'Hospice Care',
    ],
  },
  {
    planId: 'dentalplan4',
    currentPlan: false,
    planTitle: 'WellGuard Health Shield',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$96.00',
    monthlyAmount: '-$4.00',
    tierRating: '3.0',
    starRating: '5',
    copay: '$20.00',
    coinsurance: '$75.00',
    patientResponsibility: '$20.00',
    primaryCareProvider: 'Required',
    networks: [
      'Preferred Provider Organization (PPO)',
      'Indemnity Plan (Fee-for-Service)',
    ],
    genricDrugs: ['$170 (brand)', '$70 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
      'Mental Health Services',
      'Rehabilitation Services',
      'Preventive Services',
      'Chronic Disease Management',
      'Home Health Care',
      'Hospice Care',
    ],
  },
  {
    planId: 'dentalplan5',
    currentPlan: false,
    planTitle: 'WellGuard Health Shield',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$96.00',
    monthlyAmount: '-$4.00',
    tierRating: '2.0',
    starRating: '3',
    copay: '$24.00',
    coinsurance: '$45.00',
    patientResponsibility: '$23.00',
    primaryCareProvider: 'Not Required',
    networks: [
      'Preferred Provider Organization (PPO)',
      'Health Maintenance Organization (HMO)',
      'Exclusive Provider Organization(EPO)',
      'Point of Service (POS)',
    ],
    genricDrugs: ['$155 (brand)', '$75 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
      'Mental Health Services',
      'Rehabilitation Services',
      'Preventive Services',
      'Chronic Disease Management',
      'Home Health Care',
      'Hospice Care',
    ],
  },
  {
    planId: 'dentalplan6',
    currentPlan: false,
    planTitle: 'WellGuard Health Shield',
    planDesc: 'WellGuard HealthShield is a comprehensive health insurance...',
    inNetworkDeductible: '$1000.00',
    inNetworkOutOfPocket: '$800.00',
    outOfNetworkDeductible: '$1000.00',
    outOfNetworkOutOfPocket: '$800.00',
    monthlyPremium: '$96.00',
    monthlyAmount: '-$4.00',
    tierRating: '3.0',
    starRating: '5',
    copay: '$20.00',
    coinsurance: '$75.00',
    patientResponsibility: '$20.00',
    primaryCareProvider: 'Required',
    networks: ['Preferred Provider Organization (PPO)'],
    genricDrugs: ['$60 (brand)', '$20 (generic)'],
    benefits: [
      'Hospitalization Coverage',
      'Outpatient Services',
      'Emergency Medical Services',
      'Prescription Drug Coverage',
      'Specialist Consultations',
      'Surgery Coverage',
      'Maternity Care',
      'Mental Health Services',
      'Rehabilitation Services',
      'Preventive Services',
      'Chronic Disease Management',
      'Home Health Care',
      'Hospice Care',
    ],
  },
];

const DentalPlan = ({
  setSelectedCheckedItems,
  selectedCheckedItems,
  setSelectedCheckedRowData,
  selectedCheckedRowData,
  enrollmentFormData,
  setEnrollmentFormData,
  onSelectedProducts,
  onSelectedEnrollMembers,
  selectedTab,
  isTabClicked,
  setIsTabClicked,
}) => {
  /*const [selectedCheckedItems, setSelectedCheckedItems] = useState([]);
    const [selectedCheckedRowData, setSelectedCheckedRowData] = useState([]);
    console.log('selectedCheckedItems', selectedCheckedItems);
    console.log('selectedCheckedRowData', selectedCheckedRowData);*/
  return (
    <div className="plan-selection-row">
      <div className="padTB-2">
        <GenericMessage
          wrapperClasses="mt-4 mb-4"
          message="Disclaimer Placeholder would be here:"
          messageType={'warning'}
          showMessage={true}
          hideCloseButton={true}
        />
      </div>
      <div>
        {planData &&
          planData.map((d, index) => (
            <ProductDentalRow
              key={index}
              data={d}
              selectedCheckedItems={selectedCheckedItems}
              setSelectedCheckedItems={setSelectedCheckedItems}
              selectedCheckedRowData={selectedCheckedRowData}
              setSelectedCheckedRowData={setSelectedCheckedRowData}
              enrollmentFormData={enrollmentFormData}
              setEnrollmentFormData={setEnrollmentFormData}
              onSelectedProducts={onSelectedProducts}
              onSelectedEnrollMembers={onSelectedEnrollMembers}
              selectedTab={selectedTab}
              isTabClicked={isTabClicked}
              setIsTabClicked={setIsTabClicked}
            />
          ))}
      </div>
    </div>
  );
};

export default DentalPlan;
